// Moment of Force (Torque) units with conversion factors to newton-meter (N·m)
export const momentForceUnits = [
  { id: 'newton-meter', name: 'Newton-meter', symbol: 'N·m', plural: 'Newton-meters', toBase: 1 },
  { id: 'newton-centimeter', name: 'Newton-centimeter', symbol: 'N·cm', plural: 'Newton-centimeters', toBase: 0.01 },
  { id: 'newton-millimeter', name: 'Newton-millimeter', symbol: 'N·mm', plural: 'Newton-millimeters', toBase: 0.001 },
  { id: 'kilonewton-meter', name: 'Kilonewton-meter', symbol: 'kN·m', plural: 'Kilonewton-meters', toBase: 1000 },
  { id: 'dyne-meter', name: 'Dyne-meter', symbol: 'dyn·m', plural: 'Dyne-meters', toBase: 1e-5 },
  { id: 'dyne-centimeter', name: 'Dyne-centimeter', symbol: 'dyn·cm', plural: 'Dyne-centimeters', toBase: 1e-7 },
  { id: 'dyne-millimeter', name: 'Dyne-millimeter', symbol: 'dyn·mm', plural: 'Dyne-millimeters', toBase: 1e-8 },
  { id: 'kilogram-force-meter', name: 'Kilogram-force-meter', symbol: 'kgf·m', plural: 'Kilogram-force-meters', toBase: 9.80665 },
  { id: 'kilogram-force-centimeter', name: 'Kilogram-force-centimeter', symbol: 'kgf·cm', plural: 'Kilogram-force-centimeters', toBase: 0.0980665 },
  { id: 'kilogram-force-millimeter', name: 'Kilogram-force-millimeter', symbol: 'kgf·mm', plural: 'Kilogram-force-millimeters', toBase: 0.00980665 },
  { id: 'gram-force-meter', name: 'Gram-force-meter', symbol: 'gf·m', plural: 'Gram-force-meters', toBase: 0.00980665 },
  { id: 'gram-force-centimeter', name: 'Gram-force-centimeter', symbol: 'gf·cm', plural: 'Gram-force-centimeters', toBase: 0.0000980665 },
  { id: 'gram-force-millimeter', name: 'Gram-force-millimeter', symbol: 'gf·mm', plural: 'Gram-force-millimeters', toBase: 0.00000980665 },
  { id: 'ounce-force-foot', name: 'Ounce-force-foot', symbol: 'ozf·ft', plural: 'Ounce-force-feet', toBase: 0.08468521 },
  { id: 'ounce-force-inch', name: 'Ounce-force-inch', symbol: 'ozf·in', plural: 'Ounce-force-inches', toBase: 0.007061768 },
  { id: 'pound-force-foot', name: 'Pound-force-foot', symbol: 'lbf·ft', plural: 'Pound-force-feet', toBase: 1.355818 },
  { id: 'pound-force-inch', name: 'Pound-force-inch', symbol: 'lbf·in', plural: 'Pound-force-inches', toBase: 0.112984829 },
];

export const popularMomentForceConversions = [
  { from: 'newton-meter', to: 'pound-force-foot' },
  { from: 'pound-force-foot', to: 'newton-meter' },
  { from: 'newton-meter', to: 'kilogram-force-meter' },
  { from: 'pound-force-foot', to: 'pound-force-inch' },
  { from: 'newton-meter', to: 'newton-centimeter' },
  { from: 'kilogram-force-meter', to: 'newton-meter' },
];

export const getUnitById = (id) => momentForceUnits.find(unit => unit.id === id);

export const convertMomentForce = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert torque (moment of force) units and learn the conversion formula.`;
};
